import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/services/jwt.service";
//import DomainService from "./domain.service";
import { API_URL } from "@/services/config.service";
import colors from "vuetify/lib/util/colors";
//let API_URL = process.env.VUE_APP_API_URL;

try {
  let api = API_URL; //DomainService.getApi(hostname);
  if (api) {
    API_URL = api;
  }
} catch (err) {}

const configMultipart = {
  headers: { "content-type": "multipart/form-data" }
};

const configCross = {
  headers: { "X-REMOTE-DOMAIN": 1 }
};
const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = API_URL;
    Vue.axios.interceptors.request.use(
      function(config) {
        config.withCredentials = true;
        return config;
      },
      function(error) {
        return Promise.reject(error);
      }
    );
  },

  setHeader() {
    // console.log("set header");
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${JwtService.getToken()}`;
    Vue.axios.defaults.headers.common["X-REMOTE-DOMAIN"] = "1";
  },
  getHeader() {
    return {
      Authorization: `Bearer ${JwtService.getToken()}`
    };
  },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  get(resource, slug = "") {
    return Vue.axios.get(`${resource}/${slug}`).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  post(resource, params) {
    return Vue.axios.post(`${resource}`, params);
  },

  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params);
  },

  put(resource, params) {
    return Vue.axios.put(`${resource}`, params);
  },

  delete(resource) {
    return Vue.axios.delete(resource).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  }
};

export default ApiService;

export const EmployeeService = {
  query(page, params) {
    //return ApiService.query("employee" + (type === "feed" ? "/feed" : ""), {
    // return ApiService.query("employee" + "?page_number=" + page, {
    return ApiService.query("employee", {
      params: params
    });
  },
  fetch(page) {
    return ApiService.get("employee" + "?page_number=" + page);
  },
  get(slug) {
    return ApiService.get("employee", slug);
  },
  post(slug, payload) {
    //console.log(payload)
    return ApiService.post("employee" + "/", {
      employee: payload
    });
  },
  create(params) {
    return ApiService.post("employee", { employee: params });
  },
  update(slug, params) {
    return ApiService.put(`employee/${slug}`, { employee: params });
  },
  upload(slug, params) {
    return ApiService.put(`employee/upload-image/${slug}`, { image: params });
  },
  destroy(slug) {
    return ApiService.delete(`employee/${slug}`);
  }
};

export const DependentService = {
  query(type, params) {
    return ApiService.query("dependent", {
      params: params
    });
  },
  get(slug) {
    return ApiService.get("dependent", slug);
  },
  get_by_employee(slug) {
    return ApiService.get("dependent", `employee_dependent/${slug}`);
  },
  /* create(params) {
    return ApiService.post("dependent", { dependent: params });
  },*/
  post(slug, payload) {
    //console.log(payload)
    return ApiService.post("dependent" + "/", { dependent: payload });
  },
  update(slug, params) {
    // console.log(params.image)
    return ApiService.put(`dependent/${slug}`, { dependent: params });
  },
  upload(slug, params) {
    return ApiService.put(`dependent/upload-image/${slug}`, { image: params });
  },
  destroy(slug) {
    return ApiService.delete(`dependent/${slug}`);
  }
};

export const InsuranceService = {
  query(type, params) {
    //return ApiService.query("employee" + (type === "feed" ? "/feed" : ""), {
    return ApiService.query("employee", {
      params: params
    });
  },
  get(slug) {
    return ApiService.get("insurance", slug);
  },
  post(slug, payload) {
    return ApiService.post("insurance" + "/insurance-verified", payload);
  },
  create(params) {
    return ApiService.post("employee", { employee: params });
  },
  update(slug, params) {
    return ApiService.put(`employee/${slug}`, { employee: params });
  },
  destroy(slug) {
    return ApiService.delete(`employee/${slug}`);
  }
};

export const ManifestService = {
  query(type, params) {
    return ApiService.query("manifest", {
      params: params
    });
  },
  get(slug) {
    return ApiService.get("manifest", slug);
  }
};

export const DepartedVesselsService = {
  query(type, params) {
    return ApiService.query("departed_vessel", {
      params: params
    });
  },
  post(slug, payload) {
    return ApiService.post(`departed_vessel/${slug}`, payload);
  },
  update(slug, payload) {
    // console.log(params.image)
    return ApiService.put(`departed_vessel/${slug}`, {
      departed_vessel: payload
    });
  },
  get(slug) {
    return ApiService.get("departed_vessel", slug);
  }
};

export const DeliveryOrderService = {
  get(slug) {
    return ApiService.get("delivery_orders", slug);
  },
  get_by_vessel(slug) {
    return ApiService.get("delivery_orders", `dos/${slug}`);
  },
  get_do_items(slug) {
    return ApiService.get("delivery_orders", `items/${slug}`);
  },
  get_jsreport(slug, payload) {
    return axios.post(`delivery_orders/${slug}`, payload, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/pdf"
      }
    });
    // return ApiService.post(`delivery_orders/${slug}`, payload);
  },

  post(slug, payload) {
    return ApiService.post(`delivery_orders/${slug}`, payload);
  },
  set_delivery(slug, payload) {
    // console.log(params.image)
    return ApiService.put(`delivery_orders/${slug}`, {
      delivery_order: payload
    });
  },
  add_waver(slug, payload) {
    // console.log(params.image)
    return ApiService.put(`delivery_orders/${slug}`, {
      delivery_order: payload
    });
  },
  rate_again(slug, payload) {
    return ApiService.put(`delivery_orders/${slug}`, {
      delivery_order: payload
    });
  },
  authorised_delivery(slug, payload) {
    return ApiService.put(`delivery_orders/${slug}`, {
      delivery_order: payload
    });
  },
  verify_do(slug, payload) {
    return ApiService.put(`delivery_orders/${slug}`, {
      delivery_order: payload
    });
  }
};
export const UserLoginService = {
  reset_password(slug, payload) {
    // console.log("api service", payload)
    return ApiService.put(`users/${slug}`, {
      user: payload
    });
  }
};

export const ReportingServices = {
  get_weekly_sales_counts(slug, payload) {
    return ApiService.query(`delivery_orders/${slug}`, {
      params: payload
    });
  },
  get_jsreports(slug, payload) {
    //console.log("hi from api get html report")
    if (payload.format === "html") {
      return axios.post(`delivery_orders/${slug}`, payload, {
        responseType: "text",
        headers: {
          "Content-Type": "application/json",
          Accept: "text/html"
        }
      });
    } else if (payload.format === "pdf") {
      //console.log(payload.format);
      return axios.post(`delivery_orders/${slug}`, payload, {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf"
        }
      });
    } else {
      return axios.post(`delivery_orders/${slug}`, payload, {
        responseType: "blob"
        // headers: {
        //   "Content-Type": "application/json",
        //   Accept: "application/pdf"
        // }
      });
    }
  }
};
